import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { SchemaBranchMixin } from 'legacy/libs/baobab-react-mixins'
import { ResolveMixin } from 'legacy/libs/baobab-react-resolver'
import { FormComponentMixin } from 'legacy/libs/react-form-tools'
import BaobabPropTypes from 'legacy/libs/baobab-prop-types'
import createReactClass from 'create-react-class'
import TagSelect from '../tag-select'
import SuggestTag from '../suggest-tag'
import Spinner from '../../spinner'

import s from './tag-select-tree.module.scss'

export default createReactClass({
  displayName: 'TagSelectTree',

  mixins: [SchemaBranchMixin, ResolveMixin, FormComponentMixin],

  propTypes: {
    onChange: PropTypes.func,
    service: PropTypes.func.isRequired,
    createService: PropTypes.func,
    deleteService: PropTypes.func,
    approveService: PropTypes.func,
    refuseService: PropTypes.func,
    tree: PropTypes.oneOfType([BaobabPropTypes.baobab, BaobabPropTypes.cursor]),
  },

  schema: {
    childrenTags: {
      data: [],
    },
    childrenCount: 0,
    pk: null,
  },

  expertSuggestionsBlockedTagGroups: ['Language'],

  cursors(props, context) {
    return {
      selectedTags: this.getCursor(props, context),
    }
  },

  getResolverBindings() {
    if (!this.state.childrenCount) {
      return []
    }

    return [
      {
        cursor: this.cursors.childrenTags,
        service: () => this.props.service(this.state.pk),
      },
    ]
  },

  renderChild(childCursor, index) {
    return (
      <TagSelect
        tree={childCursor}
        key={index}
        entryTagGroupName={this.props.entryTagGroupName}
        {..._.pick(this.props, [
          'onChange',
          'cursor',
          'service',
          'createService',
          'deleteService',
          'approveService',
          'refuseService',
        ])}
      />
    )
  },

  render() {
    const childrenTagsCursor = this.cursors.childrenTags.select('data')

    return (
      <div className={s.subtree}>
        {this.isFullyLoaded() ? (
          childrenTagsCursor.map(this.renderChild)
        ) : (
          <Spinner loading />
        )}
        {!this.expertSuggestionsBlockedTagGroups.includes(
          this.props.entryTagGroupName
        ) && (
          <SuggestTag
            tree={this.props.tree}
            cursor={this.cursors.selectedTags}
            createService={this.props.createService}
          />
        )}
      </div>
    )
  },
})
